var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconography / Icons / Info"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5982_11722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5982_11722)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 12,
    cy: 12,
    r: 10.5,
    stroke: "#195096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0783 5.7444C14.0783 6.22394 13.9058 6.63013 13.5597 6.96525C13.2146 7.29923 12.7976 7.46623 12.3121 7.46623C11.8265 7.46623 11.4141 7.29923 11.0759 6.96525C10.7366 6.63013 10.5686 6.22394 10.5686 5.7444C10.5686 5.26373 10.7366 4.85414 11.0759 4.51113C11.4141 4.17038 11.8265 4 12.3121 4C12.7976 4 13.2146 4.17038 13.5597 4.51113C13.9058 4.85414 14.0783 5.26373 14.0783 5.7444ZM9 16.3823C9 16.195 9.01485 15.9795 9.04456 15.7391C9.07426 15.4999 9.11882 15.2415 9.17594 14.964L10.1265 9.77253H13.306L12.2686 15.3792C12.2389 15.5101 12.2161 15.6297 12.2012 15.7391C12.1864 15.8474 12.1795 15.9625 12.1795 16.0765C12.1795 16.3676 12.2492 16.5764 12.3898 16.6982C12.5291 16.8223 12.7611 16.8844 13.0844 16.8844C13.4968 16.8844 13.8875 16.7072 14.2554 16.3496C14.5566 16.0586 14.7934 15.6965 14.9666 15.2628C15.0365 15.0877 15.2008 14.964 15.3893 14.964V14.964C15.687 14.964 15.8949 15.2591 15.7789 15.5333C15.3364 16.5795 14.777 17.3922 14.1 17.9743C13.306 18.657 12.3932 19 11.3627 19C10.6269 19 10.0488 18.7709 9.62951 18.314C9.21022 17.8547 9 17.2105 9 16.3823Z",
    stroke: "#195096",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.3e80a8bcd522295d23194c06d2b3e730.svg";
export { ForwardRef as ReactComponent };